import createNamespaceContext from './helper/createNamespaceContext';
export var OMNI_CHANNEL_CONTEXT = 'omniChannelCtx';
export var OmniChannelAnalyticsContext = createNamespaceContext(OMNI_CHANNEL_CONTEXT, 'OmniChannelAnalyticsContext');